const jp: Record<string, string> = {
  create_new_lobby: "新しいロビーを作成", // FrontPage — main CTA button
  join_lobby: "ロビーに参加", // FrontPage — join button
  switch_language: "日本語", // FrontPage — language toggle button
  invalid_lobbyKey: "無効なロビーです。予期せず発生した場合は、こちらからフィードバックを送信してください:", // Lobby — error when lobby key is invalid
  host_is_configuring: "ホストがゲームを設定中です...", // Lobby — message shown to non-host players
  start_game: "ゲーム開始", // Lobby — host start button
  see_all: "全結果を見る", // MobileResults — show all results button
  you_did_not_answer: "あなたは質問に答えませんでした", // MobileResults — shown when player didn't submit
  set_your_name: "名前を設定", // Lobby — name input prompt
  confirm: "確認", // Lobby — name confirm button
  recommendation: "本名の使用をおすすめしますが、必須ではありません", // Lobby — name input hint
  thanks_for_playing: "プレイありがとうございました", // EndPanel — end screen heading
  more_stuff: "新機能が近日公開予定", // EndPanel — end screen subheading
  knows_you_best: "あなたを一番よく知っている人: <h>{{bestPlayerName}}</h>", // EndPanel — best predictor stat
  best_accuracy: "予測精度: <h>{{bestPlayerAccuracy}}%</h>", // EndPanel — best accuracy stat
  winner: "勝者: <h>{{winnerName}}</h>", // EndPanel — winner announcement
  winning_score: "スコア: <h>{{winnerScore}}</h>", // EndPanel — winner score
  knows_you_worst: "あなたを一番知らない人: <h>{{worstPlayerName}}</h>", // EndPanel — worst predictor stat
  worst_accuracy: "予測精度: <h>{{worstPlayerAccuracy}}%</h>", // EndPanel — worst accuracy stat
  attracted_to: "惹かれるタイプ", // Lobby — player config field
  provide_info:
    "はい、ゲーム体験を向上させるために自分の情報を提供します", // Lobby — player config opt-in
  my_age: "年齢", // Lobby — player config field
  player_config: "プレイヤー設定", // Lobby — player config section heading
  your_answer: "あなたの回答:", // MobileResults — czar answer label
  did_not_answer: "あなたは質問に答えませんでした", // MobileResults — no-answer fallback
  you_scored: "<h>{{score}}</h>ポイント獲得!", // MobileResults — score display with points
  calculating_error: "ポイント減算中: <h>-{{score}}</h>", // MobileResults — penalty animation text
  this_is_how_answered: "{{name}}の回答はこちら", // MobileResults — other player's answer label
  lets_calculate: "さあ、予測の結果を見てみましょう...", // MobileResults — transition text before scoring
  player_submissons: "プレイヤーの回答", // MobileResults — section heading
  see_mine: "自分の結果を見る", // MobileResults — toggle to own results
  start_next_round: "次のラウンドを開始", // MobileResults — host next round button
  waiting_next_round: "ホストを待機中", // MobileResults — non-host waiting text
  explain_decision: "決定の理由を説明しますか?", // MobileResults — czar explanation prompt
  czar_tier_perfect: "全員があなたを完璧に予測しました!", // MobileResults — tier message for czar
  czar_tier_great: "みんなあなたのことをよく知りすぎている...", // MobileResults — tier message for czar
  czar_tier_good: "みんなあなたのことをよくわかっていますね!", // MobileResults — tier message for czar
  czar_tier_average: "みんなの予測はまあまあでした...", // MobileResults — tier message for czar
  czar_tier_bad: "みんなはこの予測に苦戦しました", // MobileResults — tier message for czar
  czar_tier_terrible: "みんなあなたと正反対に思っていました", // MobileResults — tier message for czar
  czar_tier_perfect_duo: "{{name}}があなたを完璧に予測しました!", // MobileResults — tier message (2-player)
  czar_tier_great_duo: "{{name}}はあなたのことをよく知りすぎている...", // MobileResults — tier message (2-player)
  czar_tier_good_duo: "{{name}}はあなたのことをよくわかっていますね!", // MobileResults — tier message (2-player)
  czar_tier_average_duo: "{{name}}の予測はまあまあでした...", // MobileResults — tier message (2-player)
  czar_tier_bad_duo: "{{name}}はこの予測に苦戦しました", // MobileResults — tier message (2-player)
  czar_tier_terrible_duo: "{{name}}はあなたと正反対に思っていました", // MobileResults — tier message (2-player)
  czar_nobody_answered: "誰も予測を提出しませんでした", // MobileResults — no submissions fallback
  go_to_play: "プレイ", // FrontPage — nav link
  go_to_how_to_play: "遊び方", // FrontPage — nav link
  go_to_FAQ: "FAQ", // FrontPage — nav link
  submit: "送信", // SubmitButton — submit button text
  waiting: "待機中", // SubmitButton — waiting state text
  intro_for_tsar: "このラウンドは<h>あなた</h>が主役!", // TurnBurst — burst headline for czar
  intro_about_tsar: "このラウンドは<h>{{tsar}}</h>が主役!", // TurnBurst — burst headline for others
  burst_subtitle_tsar: "正直に答えてください", // TurnBurst — burst subtitle for czar
  burst_subtitle_other: "ランキングを予測しよう", // TurnBurst — burst subtitle for others
  ftl_burst_headline_tsar: "あなたがリーダーです!", // TurnBurst — FTL burst for leader
  ftl_burst_subtitle_tsar: "他のプレイヤーがあなたの選択を追いかけます", // TurnBurst — FTL subtitle for leader
  ftl_burst_headline_other: "Follow the Leader \u2014 <h>{{tsar}}</h>についていこう!", // TurnBurst — FTL burst for followers
  ftl_burst_subtitle_other: "新しいリーダーは{{tsar}}です。できるだけ長くついていきましょう", // TurnBurst — FTL subtitle for followers
  ftl_still_running: "生存中", // FtlStatusBar — alive players heading
  ftl_graveyard: "脱落者", // FtlStatusBar — eliminated players heading
  ftl_multiplier: "倍率", // FtlStatusBar — multiplier label
  ftl_leader_has_chosen: "リーダーが選びました!", // FtlReveal — reveal phase heading
  ftl_you_survived: "生き残りました!", // FtlReveal — survival message
  ftl_you_were_eliminated: "脱落!", // FtlReveal — elimination message
  ftl_streak_results: "ストリーク結果", // FtlStreakResults — panel heading
  ftl_game_mode_label: "ゲームモード", // Lobby — mode selector label
  ftl_standard: "スタンダード", // Lobby — mode option
  ftl_follow_the_leader: "Follow the Leader", // Lobby — mode option
  // ─── Reverse Round ───────────────────────────────────────
  rr_burst_headline: "全員の意見が大事!", // TurnBurst — RR burst heading
  rr_burst_subtitle: "正直に答えてください \u2014 自分なりにランク付けしよう", // TurnBurst — RR burst subtitle
  rr_guess_burst_headline: "<h>リバースラウンド</h>", // TurnBurst — RR guess phase burst
  rr_guess_burst_subtitle: "これは誰の好みでしょうか?", // TurnBurst — RR guess phase subtitle
  rr_stage1_header: "正直に答えてください", // ReverseRoundPanel — submission phase heading
  rr_stage2_header: "これは誰のランキング?", // ReverseRoundPanel — guessing phase heading
  rr_high_roll_prompt: "ハイステークスで勝負する?", // ReverseRoundPanel — high roll prompt
  rr_high_roll_accept: "やっちゃえ!", // ReverseRoundPanel — accept high roll button
  rr_high_roll_decline: "やめとく", // ReverseRoundPanel — decline high roll button
  rr_not_in_group: "この中にはいない", // ReverseRoundPanel — guess option
  rr_not_player: "{{name}}ではない", // ReverseRoundPanel — guess option
  rr_submitted_by: "{{name}}が提出", // ReverseRoundResults — sequence attribution
  rr_random_sequence: "ランダム配列", // ReverseRoundResults — random sequence label
  rr_shown_to: "表示先", // ReverseRoundResults — shown-to label
  rr_guessed_correctly: "正解", // ReverseRoundResults — correct guess label
  rr_thought_it_was: "{{name}}だと思った", // ReverseRoundResults — wrong guess label
  rr_mode_label: "リバースラウンド", // Lobby — mode selector label
  rr_mode_description: "社会的推理モード", // Lobby — mode selector description
  // ─── Run with the Herd ────────────────────────────────────
  herd_burst_headline: "<h>群れについていけ!</h>", // TurnBurst — Herd burst heading
  herd_burst_subtitle: "多数派を選べ \u2014 さもないと踏み潰されるぞ!", // TurnBurst — Herd burst subtitle
  herd_still_running: "生存中", // HerdChoicePanel — alive label
  herd_trampled: "踏み潰された", // HerdChoicePanel — eliminated label
  herd_you_survived: "群れについていけました!", // HerdChoicePanel — survival message
  herd_you_were_trampled: "踏み潰された!", // HerdChoicePanel — elimination message
  herd_split: "群れが分裂!", // HerdStreakResults — split announcement
  herd_streak_results: "群れの結果", // HerdStreakResults — panel heading
  herd_votes: "票", // HerdStreakResults — vote count label
  herd_game_mode_label: "Run with the Herd", // Lobby — mode selector label
  // ─── Picasso ────────────────────────────────────────────────
  picasso_burst_headline: "<h>ピカソタイム!</h>", // TurnBurst — Picasso burst heading
  picasso_burst_subtitle: "答えを描こう \u2014 アートで表現!", // TurnBurst — Picasso burst subtitle
  picasso_gallery_burst_headline: "<h>ギャラリータイム!</h>", // TurnBurst — gallery phase burst
  picasso_gallery_burst_subtitle: "これは誰が描いた? 当ててみよう!", // TurnBurst — gallery phase subtitle
  picasso_game_mode_label: "Picasso", // Lobby — mode selector label
  picasso_archive_which_real: "このゲームで描かれたのはどれ?", // PicassoImposterReveal — archive mode question
  picasso_from_another_lobby: "別のロビーから", // PicassoImposterReveal — archive label
  picasso_imposter_accept: "受け入れる", // PicassoCanvas — accept impersonation button
  picasso_imposter_decline: "断る", // PicassoCanvas — decline impersonation button
  picasso_impersonating: "{{name}}になりすまし中", // PicassoCanvas — impersonation status text
  // ─── Homepage / Community ───────────────────────────────────
  frontpage_tagline: "お互いを知るパーティーゲーム", // FrontPage — hero tagline
  frontpage_explore_community: "コミュニティを探索", // FrontPage — community nav button
  frontpage_cta_title: "クリエイターになろう", // FrontPage — creator CTA heading
  frontpage_cta_subtitle: "ゲームに貢献しよう \u2014 自分だけのデッキを作ろう", // FrontPage — creator CTA subtitle
  frontpage_create_deck: "デッキを作成", // FrontPage — create deck button
  frontpage_profile: "プロフィール", // FrontPage — profile nav link
  frontpage_login: "ログイン", // FrontPage — login button
  frontpage_logout: "ログアウト", // FrontPage — logout button
  frontpage_community: "コミュニティ", // FrontPage — community nav link
  community_title: "コミュニティ", // CommunityPage — page heading
  community_tab_gallery: "ギャラリー", // CommunityPage — tab label
  community_tab_analytics: "分析", // CommunityPage — tab label
  community_tab_leaderboard: "リーダーボード", // CommunityPage — tab label
  community_gallery_count: "{{count}}作品", // CommunityPage — drawing count
  community_gallery_empty: "まだ作品がありません", // CommunityPage — empty state
  community_spotlight_close: "閉じる", // CommunityPage — spotlight close button
  community_analytics_empty: "分析データはまだありません。まずゲームをプレイしましょう!", // CommunityPage — empty state
  community_analytics_category: "カテゴリー", // CommunityPage — category selector label
  community_analytics_elo_title: "ELOランキング", // CommunityPage — ELO section heading
  community_analytics_pca_title: "意見グループ", // CommunityPage — PCA section heading
  community_analytics_pca_subtitle: "好みによるプレイヤーの分布 \u2014 {{pc1}}% + {{pc2}}%の分散を説明", // CommunityPage — PCA description
  community_analytics_welcome: "プレイヤーはこれらのカードをどうランク付けする?", // CommunityPage — welcome heading
  community_analytics_welcome_sub: "質問やカテゴリーごとのELOランキングと好みのパターンを探索しよう。カテゴリーを選んでから質問を選ぶと、プレイヤーが回答カードをどうランク付けしたか見られます。", // CommunityPage — welcome description
  community_insights_title: "面白い発見", // CommunityPage — insights section heading
  community_insights_subtitle: "プレイヤーのランク付けから見えるストーリー", // CommunityPage — insights description
  community_insight_divided: "大分裂", // CommunityPage — insight card title
  community_insight_consensus: "全員一致", // CommunityPage — insight card title
  community_insight_chaos: "完全なカオス", // CommunityPage — insight card title
  community_insight_two_camps: "二つの陣営", // CommunityPage — insight card title
  community_insight_players: "{{count}}人のプレイヤー", // CommunityPage — player count label
  community_insight_see_full: "全分析を見る", // CommunityPage — link to analytics
  community_decks_title: "デッキで探索", // CommunityPage — decks section heading
  community_decks_subtitle: "分析データのあるデッキ \u2014 クリックして探索", // CommunityPage — decks section description
  community_decks_questions: "{{count}}問", // CommunityPage — question count
  community_decks_categories: "{{count}}カテゴリー", // CommunityPage — category count
  community_deepdive_title: "ディープダイブ", // CommunityPage — deep dive heading
  community_deepdive_subtitle: "全カテゴリーと質問を閲覧", // CommunityPage — deep dive description
  round: "ラウンド", // Timer — round counter label
  out_of: "/", // Timer — round counter separator
  wait_for_restart: "ホストの再開を待機中", // EndPanel — non-host waiting text
  restart_lobby: "次のゲーム", // EndPanel — host restart button
  send: "送信", // FeedbackPage — send button
  feedback: "フィードバック:", // FeedbackPage — field label
  from: "送信者:", // FeedbackPage — sender field label
  thx4Impro: "改善に協力してくれてありがとう :)", // FeedbackPage — thank you message
  get_back: "さあゲームに戻ろう", // FeedbackPage — return prompt
  give_feedback: "フィードバック", // Lobby — feedback button
  quickFeedBackQuestion: "<h>あなた</h>ならゲームの何を改善しますか?", // ReportPanel — feedback question text
  quick_feedback: "クイックフィードバック", // ReportPanel — feedback section heading
  skip: "スキップ({{remainingSkips}})", // Game — skip button with remaining count
  card_deck_specs: "質問: {{questions}}\n回答: {{answers}}\nカテゴリー: {{categories}}", // CardDeckBrowser — tooltip with deck stats
  card_deck_specs_questions: "質問: {{questions}}", // CardDeckBrowser — question count
  card_deck_specs_answers: "回答: {{answers}}", // CardDeckBrowser — answer count
  card_deck_specs_categories: "カテゴリー: {{categories}}", // CardDeckBrowser — category count
  card_deck_specs_play: "プレイ", // CardDeckBrowser — singular play count
  card_deck_specs_plays: "プレイ", // CardDeckBrowser — plural play count
  card_deck_specs_language: "言語: {{language}}", // CardDeckBrowser — language label
  queue_title: "待合室", // QueuePage — page heading
  queue_position_of: "キュー内の位置: {{position}} / {{total}}", // QueuePage — position indicator
  queue_membership_prompt: "メンバーシップコードをお持ちですか? 入力するとキューをスキップできます。", // QueuePage — code entry prompt
  queue_code_placeholder: "メンバーシップコード", // QueuePage — code input placeholder
  queue_invalid_code: "無効なメンバーシップコード", // QueuePage — error message
  queue_submit_code: "コードを送信", // QueuePage — submit button
  queue_leave: "キューを離れる", // QueuePage — leave button
  queue_timeout: "キューの順番が期限切れになりました。もう一度お試しください。", // QueuePage — timeout message
  // ─── Profile / Creator Stats ───────────────────────────────
  global_rank: "グローバルランク", // ProfilePage — stat label
  language_rank: "言語ランク", // ProfilePage — stat label
  total_plays: "{{count}}回プレイ", // ProfilePage — stat with count
  unique_players: "{{count}}人のユニークプレイヤー", // ProfilePage — stat with count
  out_of_creators: "{{total}}人中#{{rank}}位", // ProfilePage — rank display
  no_play_data: "デッキを共有してプレイ統計をここに表示しましょう", // ProfilePage — empty state
  name_taken: "使用済み", // ProfilePage — username validation
  name_saved: "保存完了", // ProfilePage — save confirmation
  daily_plays_chart_title: "プレイ数", // ProfilePage — chart heading
  stats_7d: "7日", // ProfilePage — date range toggle
  stats_30d: "30日", // ProfilePage — date range toggle
  profile_dashboard: "ダッシュボード", // ProfilePage — tab label
  profile_my_decks: "マイデッキ", // ProfilePage — tab label
  profile_settings: "設定", // ProfilePage — tab label
  profile_top_decks: "トップパフォーマンスデッキ", // ProfilePage — section heading
  profile_search_decks: "デッキを検索...", // ProfilePage — search placeholder
  profile_bio_placeholder: "自己紹介を書こう...", // ProfilePage — bio textarea placeholder
  // ─── Leaderboard & Creator Profile ─────────────────────────
  leaderboard_title: "クリエイターリーダーボード", // LeaderboardPage — page heading
  leaderboard_back: "戻る", // LeaderboardPage — back button
  leaderboard_global: "グローバル", // LeaderboardPage — tab label
  leaderboard_creator: "クリエイター", // LeaderboardPage — column header
  leaderboard_plays: "プレイ数", // LeaderboardPage — column header
  leaderboard_decks: "デッキ", // LeaderboardPage — column header
  leaderboard_load_more: "もっと見る", // LeaderboardPage — pagination button
  leaderboard_empty: "クリエイターが見つかりません", // LeaderboardPage — empty state
  creator_not_found: "クリエイターが見つかりません", // CreatorProfilePage — error state
  creator_back_to_leaderboard: "リーダーボードに戻る", // CreatorProfilePage — back button
  creator_no_decks: "このクリエイターにはまだデッキがありません", // CreatorProfilePage — empty state
  creator_decks_title: "{{count}}デッキ", // CreatorProfilePage — section heading
  explainer_default: "各色 = ランク", // ExplainerOverlay — default color legend
  explainer_high: "高評価 \u00b7 よく1位にランクされる", // ExplainerOverlay — high rank legend
  explainer_low: "低評価 \u00b7 よく5位にランクされる", // ExplainerOverlay — low rank legend
  // ─── Friend Pool ─────────────────────────────────────────────
  friend_pool_title: "お互いについての質問", // Lobby — friend pool section heading
  friend_pool_add_placeholder: "友達を追加", // FriendPoolEditor — add friend input placeholder
  friend_pool_login_hint: "ログインするとフレンドグループを保存できます", // FriendPoolEditor — login prompt

  // ─── Old Lobby Config (GameConfigPanel) ────────────────────────
  game_config: "ゲーム設定", // GameConfigPanel — section heading
  game_mode: "ゲームモード:", // GameConfigPanel — mode label
  speed: "速度:", // GameConfigPanel — speed label
  rounds: "ラウンド:", // GameConfigPanel — rounds label
  family_friendly: "ファミリー向け", // GameConfigPanel — mode option
  party: "通常", // GameConfigPanel — mode option
  slow: "ゆっくり (おすすめ)", // GameConfigPanel — speed option
  medium: "普通", // GameConfigPanel — speed option
  fast: "速い", // GameConfigPanel — speed option
  one_round: "1", // GameConfigPanel — round option
  two_rounds: "2", // GameConfigPanel — round option
  three_rounds: "3 (おすすめ)", // GameConfigPanel — round option
  five_rounds: "5", // GameConfigPanel — round option

  // ─── FAQ / Bela ────────────────────────────────────────────────
  honorable_mention: "Honorable Mention", // FAQ — bela section heading
  bela_thanks:
    "I want to sincerly thank my friend Bela, who mentored this code project in his freetime and helped me with his expertise in programming, deployment and networking.", // FAQ — bela tribute text
  secret_admirer: "A secret admirer", // FeedbackPage — anonymous sender placeholder

  // ─── Bela Quotes (BelaQuote) ───────────────────────────────────
  bela_q_1: "Erweiterbarkeit, dies das",
  bela_q_2: "Das ist ja auch nicht schwer",
  bela_q_3: "Das wird dir beim deployment vermutlich um die ohren fliegen.",
  bela_q_4: "Ich würde ja rust empfehlen, aber du willst ja noch vor weihnachten fertig werden.",
  bela_q_5: "Ich würde immer noch das Backend abfackeln und neu bauen.",
  bela_q_6: "Du bist wie gesagt fernab von den Situationen, für die das designed wurde.",
  bela_q_7:
    "Mach dir halt keine Gedanken um Skalierung, wenn du keine Probleme mit Skalierung hast.",
  bela_q_8:
    "Ja, das ist halt ehrlich gesagt gerade die falsche Metrik.\nDas Ding wird umfallen, bei mehr Benutzern, dafür musst du es nicht testen.",
  bela_q_9: "Ja also das ist bescheidenes design",
  bela_q_10:
    "Das funktioniert super, solange du nur mit einer datenbank kommunizierst\naber genau in deinem fall bricht es halt auseinander",

  // ─── Deck Tutorial (DeckTutorial.tsx) ──────────────────────────
  deck_tutorial_hero_title: "How to Create a Card Deck",
  deck_tutorial_hero_subtitle: "Everything you need to know to build your own deck. It's easier than you think, and if formatting feels tricky, AI can do it for you.",
  deck_tutorial_what_is_deck: "What is a Deck?",
  deck_tutorial_what_is_deck_body: "A deck is a collection of questions and answers organized into categories. Categories group thematically related content together. When a turn starts, the game picks a category, then picks a question and 5 answers from it.",
  deck_tutorial_hierarchy_example: "Example structure:",
  deck_tutorial_min_cards_rule: "For the Standard game mode, each category needs at least 1 question and 5 answer cards to be playable. Other game modes like Picasso have different requirements (see below).",
  deck_tutorial_questions_title: "How Questions Work: The Two Sides",
  deck_tutorial_questions_body: "Every question has two versions: one addressed to \"you\" (for the tsar) and one using the tsar's name (for everyone else).",
  deck_tutorial_questions_why: "The tsar reads \"What would you do?\" while everyone else reads \"What would Sarah do?\" — so players can focus on predicting instead of rephrasing.",
  deck_tutorial_refresh_tsar: "Click to see how it looks with different tsar names",
  deck_tutorial_formatting_title: "Formatting: Highlights and the Tsar Name",
  deck_tutorial_formatting_body: "Two special formatting tools let you make cards look great in-game:",
  deck_tutorial_formatting_tip: "The editor has \"insert tsar name\" and \"highlight selection\" buttons that do this formatting for you. No need to type the tags manually.",
  deck_tutorial_ai_title: "Too Complicated? Let AI Do It.",
  deck_tutorial_ai_body: "Just type your question in plain text, something like \"what food would you never eat\", and press the magic wand button. AI will generate both the \"for the tsar\" and \"about the tsar\" versions with proper formatting. Works in any language!",
  deck_tutorial_ai_tip: "You can always edit the AI's output if you want to tweak it.",
  deck_tutorial_answers_title: "Answer Cards",
  deck_tutorial_answers_body: "Answer cards are simpler: just text, no special formatting needed. They're the options the tsar ranks. 5 answer cards from the same category are shown each turn. Keep them short and punchy.",
  deck_tutorial_friend_token_title: "Friend Names in Answer Cards",
  deck_tutorial_friend_token_body: "Want answer cards that use your friends' names? Use the {{friend}} token. At game time, it gets replaced with actual names from the player list. This lets you create personal, social questions without having to hardcode anyone's name.",
  deck_tutorial_friend_token_example_header: "How it works:",
  deck_tutorial_friend_token_example_card: "You write an answer card: {{friend}}",
  deck_tutorial_friend_token_example_resolve: "In-game, 5 copies appear — each showing a different player's name (e.g. Sarah, Max, Jordan, Alex, Riley)",
  deck_tutorial_friend_token_no_duplicate_title: "You only need to add it once!",
  deck_tutorial_friend_token_no_duplicate_body: "A single {{friend}} card automatically produces multiple unique answer cards at game time — one per friend. You don't need to add the same card twice. The game handles the duplication for you.",
  deck_tutorial_friend_token_button_tip: "Use the \"insert friend name\" button in the answer card editor to insert the {{friend}} token at the cursor position. The preview will show it with a random name so you can see how it looks.",
  deck_tutorial_skip_to_answers: "Skip to answer cards",
  deck_tutorial_nav_questions: "How to write questions",
  deck_tutorial_nav_answers: "How to write answers",
  deck_tutorial_nav_friend: "How to write questions about my friends",
  deck_tutorial_categories_title: "Categories: Grouping It All Together",
  deck_tutorial_categories_body: "Categories are tags that connect questions and answers. When a turn starts, the game picks a category, then picks a question and 5 answers from that category. That's why you need at least 5 answer cards per category for Standard mode.",
  deck_tutorial_categories_tip: "Make categories thematic (e.g., \"food\", \"relationships\", \"hypotheticals\"). This keeps the game coherent.",
  deck_tutorial_reuse_title: "Reusing cards across categories",
  deck_tutorial_reuse_body: "Here's a powerful feature: the same card can belong to multiple categories at once. When you assign categories to a card, you're not putting it in a box. You're tagging it. One answer card like \"Pizza\" could appear in a \"food\" category, a \"guilty pleasures\" category, and a \"first date\" category. Same card, different contexts.",
  deck_tutorial_reuse_example_header: "Example: one card, many categories",
  deck_tutorial_reuse_benefit: "This means you don't have to create the same card twice. Write it once, tag it with all the categories where it fits, and the game will use it in each of those contexts. The more categories a card belongs to, the more versatile your deck becomes.",
  deck_tutorial_picasso_title: "Bonus Mode: Picasso",
  deck_tutorial_picasso_body: "Picasso is a special bonus mode that the game triggers during a match. Instead of ranking pre-made answer cards, players draw their answers. Not every question works well as a drawing prompt, so you can mark individual questions as \"Picasso compatible\" when creating them.",
  deck_tutorial_picasso_checkbox: "\"Picasso compatible\" checkbox",
  deck_tutorial_picasso_checkbox_body: "When creating a question card, you'll see a checkbox labeled \"Picasso compatible\". Check this if the question works well as a drawing prompt. The game uses this to decide which questions can appear during Picasso rounds.",
  deck_tutorial_picasso_good_title: "Good Picasso questions (visual, creative, personal):",
  deck_tutorial_picasso_good_why: "These invite expressive, personal drawings where every player's answer will look completely different. That's what makes Picasso fun.",
  deck_tutorial_picasso_bad_title: "Bad Picasso questions (abstract, no drawing value):",
  deck_tutorial_picasso_bad_why: "\"What do you value most in a friend?\" is too abstract to draw. And \"What's your favorite ice cream flavor?\" has no real drawing value. Drawing a bowl of vanilla ice cream tells you no more than just writing the word \"vanilla\". Good Picasso questions should allow for expressive, unique answers that are genuinely more interesting as drawings than as text.",
  deck_tutorial_picasso_versatile_title: "Versatile questions work everywhere",
  deck_tutorial_picasso_versatile_body: "Some questions work great in both Standard and Picasso mode. For example, \"What does your happy place look like?\" can be answered by drawing it OR by ranking a list of options like Beach, Mountains, Home, Library, Park. If you write a question like this, check the Picasso box and also make sure the category has enough answer cards for Standard mode. That way the question gets used in both modes.",
  deck_tutorial_picasso_no_answers: "Picasso-only questions don't need answer cards. If a category only has Picasso-compatible questions and no answer cards, it will only appear during Picasso rounds. The game handles this automatically.",
  deck_tutorial_preview_title: "Preview & Polish",
  deck_tutorial_preview_body: "You can preview any card by clicking the Preview button. The preview shows exactly how the card will look in-game. Click the refresh icon to see it with different tsar names. Before leaving the editor, it warns you about incomplete categories.",
  deck_tutorial_cta_title: "Ready to create?",
  deck_tutorial_cta_button: "Go to My Profile",
  deck_tutorial_back_to_howto: "Back to How to Play",

  // ═══════════════════════════════════════════════════════════════
  // NEW KEYS — added for i18n coverage
  // ═══════════════════════════════════════════════════════════════

  // ─── Generic / shared ──────────────────────────────────────────
  back: "戻る", // FeedbackPage, CardDeckBrowser — back button
  cancel: "キャンセル", // CardDeckViewer — cancel button in report dialog
  close: "閉じる", // CardDeckViewer — close button
  continue: "続ける", // FtlStreakResults, HerdStreakResults, PicassoResults — host continue button
  accept: "承諾", // PicassoCanvas — accept button
  decline: "辞退", // PicassoCanvas — decline button
  dismiss: "閉じる", // AdminMessageDialog, ShutdownDialog — dismiss button
  done: "完了", // CreateDeckConfigMenu — done button
  lock_in: "確定", // SequenceBar — submit ranking button
  ready: "準備完了", // MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — ready toggle
  unready: "準備取消", // EndPanel, MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — unready toggle
  report: "報告", // CardDeckViewer — report button
  submitted: "送信済み", // PicassoCanvas — submission status
  waiting_for_host: "ホストを待機中...", // FtlStreakResults, HerdStreakResults, PicassoResults — non-host waiting
  waiting_for_others: "他のプレイヤーを待機中...", // PicassoImposterReveal, ReverseRoundPanel — waiting message
  select_all: "すべて選択", // CardDeckBrowser, TopicSelector — bulk select
  deselect_all: "すべて解除", // CardDeckBrowser, TopicSelector — bulk deselect

  // ─── End Panel ─────────────────────────────────────────────────
  end_panel_review_game: "ゲーム全体を振り返る", // EndPanel — review game button
  end_panel_play_again: "もう一度プレイ", // EndPanel — play again button

  // ─── FTL extras ────────────────────────────────────────────────
  ftl_leader: "リーダー:", // FtlStreakResults — leader label

  // ─── Herd extras ───────────────────────────────────────────────
  herd_results: "群れの結果", // HerdStreakResults — panel heading
  herd_trampled_spectating: "踏み潰されました。観戦中...", // HerdChoicePanel — spectating message
  herd_pick_majority: "多数派を選べ!", // HerdChoicePanel — instruction text
  herd_locked_in: "確定済み。タップで変更...", // HerdChoicePanel — lock-in confirmation

  // ─── Picasso extras ────────────────────────────────────────────
  picasso_impersonate_prompt: "シーッ! なりすまし相手:", // PicassoCanvas — impersonation modal text
  picasso_eraser: "消しゴム", // PicassoCanvas — eraser button
  picasso_unsubmit: "送信取消", // PicassoCanvas — unsubmit button
  picasso_submit_drawing: "絵を送信", // PicassoCanvas — submit drawing button
  picasso_which_true_answer: "本当の回答はどれ?", // PicassoImposterReveal — question heading
  picasso_confirm_vote: "投票を確定", // PicassoImposterReveal — confirm vote button
  picasso_gallery: "ギャラリー", // PicassoResults — gallery section heading
  picasso_impersonated: "なりすまし", // PicassoResults — impersonation badge
  picasso_challenges: "チャレンジ", // PicassoResults — challenges section heading

  // ─── Reverse Round extras ──────────────────────────────────────
  rr_whose_ranking: "これは誰のランキング?", // ReverseRoundPanel — guess phase question
  rr_high_stakes_prompt: "ハイステークスで勝負する?", // ReverseRoundPanel — high roll prompt
  rr_roll_it: "やっちゃえ!", // ReverseRoundPanel — accept high roll
  rr_nah: "やめとく", // ReverseRoundPanel — decline high roll

  // ─── Deck Browser ──────────────────────────────────────────────
  deck_browser_random: "ランダム", // CardDeckBrowser — random deck button
  deck_browser_deck: "デッキ", // CardDeckBrowser — search mode toggle
  deck_browser_creator: "クリエイター", // CardDeckBrowser — search mode toggle
  deck_browser_languages: "言語", // CardDeckBrowser — language filter label
  deck_browser_create_deck: "デッキを作成", // CardDeckBrowser — create deck button
  deck_browser_max_decks: "最大30デッキまで選択可能", // CardDeckBrowser — max selection warning

  // ─── Deck Viewer ───────────────────────────────────────────────
  deck_viewer_created_by: "作成者", // CardDeckViewer — creator label
  deck_viewer_questions: "質問", // CardDeckViewer — tab label
  deck_viewer_answers: "回答", // CardDeckViewer — tab label
  deck_viewer_for_tsar: "本人向け", // CardDeckViewer — sub-tab label
  deck_viewer_about_tsar: "他者向け", // CardDeckViewer — sub-tab label
  deck_viewer_report_deck: "デッキを報告", // CardDeckViewer — report dialog title
  deck_viewer_report_why: "このデッキを報告する理由は?", // CardDeckViewer — report dialog prompt
  deck_viewer_report_reason: "理由", // CardDeckViewer — report reason label
  deck_viewer_report_offensive: "不快な内容", // CardDeckViewer — report reason option
  deck_viewer_report_inappropriate: "不適切", // CardDeckViewer — report reason option
  deck_viewer_report_spam: "スパム", // CardDeckViewer — report reason option
  deck_viewer_report_low_quality: "低品質", // CardDeckViewer — report reason option
  deck_viewer_report_details: "追加の詳細 (任意)", // CardDeckViewer — report details field label
  deck_viewer_submit_report: "報告を送信", // CardDeckViewer — submit report button

  leave: "退出", // Lobby — leave button

  // ─── Lobby UI ──────────────────────────────────────────────────
  lobby_players: "プレイヤー", // Lobby — players panel heading
  lobby_invite: "招待", // Lobby — invite button
  lobby_copied: "コピー済み！", // Lobby — invite button after copy
  lobby_by_topics: "トピック別", // Lobby — deck selection mode toggle
  lobby_pick_decks: "デッキを選ぶ", // Lobby — deck selection mode toggle

  // ─── Lobby Tabs ────────────────────────────────────────────────
  lobby_tab_presets: "プリセット", // Lobby — right panel tab
  lobby_tab_questions: "質問", // Lobby — right panel tab
  lobby_tab_custom: "カスタム", // Lobby — right panel tab

  // ─── Lobby Presets ─────────────────────────────────────────────
  lobby_preset_party: "パーティー", // LobbyPresetSelector — preset name
  lobby_preset_party_desc: "全ゲームモード、バランス良好。", // LobbyPresetSelector — preset description
  lobby_preset_bonanza: "ボナンザ", // LobbyPresetSelector — preset name
  lobby_preset_bonanza_desc: "8人以上向け。全員が常にアクションに参加。", // LobbyPresetSelector — preset description
  lobby_preset_duet: "デュエット", // LobbyPresetSelector — preset name
  lobby_preset_duet_desc: "お互いをどれだけ知っているか確かめよう。", // LobbyPresetSelector — preset description
  lobby_preset_picasso: "Picasso", // LobbyPresetSelector — preset name
  lobby_preset_picasso_desc: "お絵かきモード全開!", // LobbyPresetSelector — preset description

  // ─── Friend Pool extras ────────────────────────────────────────
  friend_pool_players: "プレイヤー (自動追加)", // FriendPoolEditor — auto-included players label
  friend_pool_extra: "追加の友達", // FriendPoolEditor — custom friends label

  // ─── Create Deck Config ────────────────────────────────────────
  config_link_created: "\u2713 リンク作成完了!", // CreateDeckConfigMenu — success message
  config_create_link_subtitle: "このデッキの共有リンクを作成", // CreateDeckConfigMenu — subtitle
  config_your_name: "あなたの名前", // CreateDeckConfigMenu — name field label
  config_name_placeholder: "例: さくら", // CreateDeckConfigMenu — name placeholder
  config_config_name: "設定名", // CreateDeckConfigMenu — config name field label
  config_config_placeholder: "例: パーティーナイト", // CreateDeckConfigMenu — config name placeholder
  config_error_name: "設定名を入力してください", // CreateDeckConfigMenu — validation error
  config_error_your_name: "名前を入力してください", // CreateDeckConfigMenu — validation error
  config_error_failed: "設定の作成に失敗しました", // CreateDeckConfigMenu — API error
  config_create_link: "リンクを作成", // CreateDeckConfigMenu — create button

  // ─── Config Preview ────────────────────────────────────────────
  config_preview_not_found: "設定が見つかりません", // ConfigPreviewPage — error
  config_preview_load_failed: "設定の読み込みに失敗しました", // ConfigPreviewPage — error
  config_preview_lobby_failed: "ロビーの作成に失敗しました", // ConfigPreviewPage — error
  config_preview_game_failed: "ゲームの開始に失敗しました", // ConfigPreviewPage — error
  config_preview_invite_text: "が特別なrank.ioバージョンであなたを招待しています", // ConfigPreviewPage — invite description
  config_preview_play_count: "人がプレイしました", // ConfigPreviewPage — play count label
  config_preview_decks_included: "含まれるデッキ:", // ConfigPreviewPage — section heading
  config_preview_and_more: "他{{count}}件", // ConfigPreviewPage — overflow text
  config_preview_creating: "ロビー作成中...", // ConfigPreviewPage — loading button text
  config_preview_play: "このデッキでプレイ", // ConfigPreviewPage — play button text

  // ─── Topics ────────────────────────────────────────────────────
  topic_self_identity: "自己とアイデンティティ", // TopicSelector via topics.ts — topic filter label
  topic_values_meaning: "価値観と意味", // TopicSelector via topics.ts — topic filter label
  topic_life_stories: "人生の物語", // TopicSelector via topics.ts — topic filter label
  topic_hypotheticals: "もしも", // TopicSelector via topics.ts — topic filter label
  topic_love_relationships: "恋愛と人間関係", // TopicSelector via topics.ts — topic filter label
  topic_sex_intimacy: "性と親密さ", // TopicSelector via topics.ts — topic filter label
  topic_social_friends: "社交と友人", // TopicSelector via topics.ts — topic filter label
  topic_awkward_cringe: "気まずい瞬間", // TopicSelector via topics.ts — topic filter label
  topic_food_drink: "食べ物と飲み物", // TopicSelector via topics.ts — topic filter label
  topic_sports_fitness: "スポーツとフィットネス", // TopicSelector via topics.ts — topic filter label
  topic_music: "音楽", // TopicSelector via topics.ts — topic filter label
  topic_movies_tv_culture: "映画・テレビ・文化", // TopicSelector via topics.ts — topic filter label
  topic_lifestyle_style: "ライフスタイルとファッション", // TopicSelector via topics.ts — topic filter label
  topic_philosophy_ethics: "哲学と倫理", // TopicSelector via topics.ts — topic filter label
  topic_dark_uncomfortable: "ダークと不快", // TopicSelector via topics.ts — topic filter label
  topic_politics_society: "政治と社会", // TopicSelector via topics.ts — topic filter label
  topic_career_ambition: "キャリアと野望", // TopicSelector via topics.ts — topic filter label
  topic_games_gaming: "ゲーム", // TopicSelector via topics.ts — topic filter label
  topic_humor_absurd: "ユーモアと不条理", // TopicSelector via topics.ts — topic filter label
  topic_travel_places: "旅行と場所", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends: "友だちをランキング", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends_needs_pool: "フレンドプールをオンにして名前を追加してください。このトピックはそこにいる人をランキングします。", // TopicSelector — shown when the friends topic is picked but the friend pool is off
  topic_18_plus: "18+", // TopicSelector via topics.ts — topic filter label
  topic_low_quality: "低品質", // TopicSelector via topics.ts — topic filter label

  // ─── Card Creator ──────────────────────────────────────────────
  card_creator_question: "質問", // CardCreationWidget — card creation form
  card_creator_answer: "回答", // CardCreationWidget — card creation form
  card_creator_for_tsar: "本人向け", // CardCreationWidget — card creation form
  card_creator_about_tsar: "他者向け", // CardCreationWidget — card creation form
  card_creator_card_text: "カードテキスト", // CardCreationWidget — card creation form
  card_creator_tsar_tooltip: "ツァーはそのラウンドの主役です。", // CardCreationWidget — card creation form
  card_creator_insert: "挿入", // CardCreationWidget — card creation form
  card_creator_tsar_name: "ツァー名", // CardCreationWidget — card creation form
  card_creator_highlight_tooltip: "ツァーの代名詞をハイライトするために使います。", // CardCreationWidget — card creation form
  card_creator_highlight_selection: "選択を\nハイライト", // CardCreationWidget — card creation form
  card_creator_friend_tooltip: "{{friend}}トークンを挿入。ゲーム中にプレイヤー/友達の名前に変換されます。", // CardCreationWidget — card creation form
  card_creator_friend_name: "友達の名前", // CardCreationWidget — card creation form
  card_creator_ai_tooltip: "AIでフォーマット \u2014 「本人向け」と「他者向け」の両方を生成", // CardCreationWidget — card creation form
  card_creator_format_ai: "AIでフォーマット", // CardCreationWidget — card creation form
  card_creator_formatting: "フォーマット中...", // CardCreationWidget — card creation form
  card_creator_preview: "プレビュー", // CardCreationWidget — card creation form
  card_creator_categories: "カテゴリー", // CardCreationWidget — card creation form
  card_creator_new_category: "新しいカテゴリー", // CardCreationWidget — card creation form
  card_creator_probability: "確率:", // CardCreationWidget — card creation form
  card_creator_picasso_compatible: "Picasso対応", // CardCreationWidget — card creation form
  card_creator_add_card: "カードを追加", // CardCreationWidget — card creation form
  card_creator_warn_highlight_title: "回答カードのテキストはハイライトできません", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_highlight_desc: "ハイライトは質問カードでのみ使用し、ツァーの名前や代名詞をハイライトするためのものです。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_title: "回答にツァー名を挿入しますか?", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_desc: "回答カードにツァーの名前を挿入することは慣例に反しており、特殊な場合にのみ行うべきです。一般的に、回答カードの情報はツァーの名前を参照する必要はありません。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_title: "「本人向け」エリアのテキストが空です", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_desc: "質問カードのテキストはどちら側も空にできません。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_title: "「回答」エリアのテキストが空です", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_desc: "回答カードのテキストは空にできません。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_title: "カテゴリーが選択されていません", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_desc: "カードには少なくとも1つのカテゴリータグが必要です。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_title: "{{friend}}カードの重複", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_desc: "このカテゴリーには既に{{friend}}カードがあります。1つの{{friend}}カードはラウンドごとに自動的に異なる友達の名前に変換されます \u2014 2つ追加する必要はありません。", // CardCreationWidget — warning props for CardWarning
  card_creator_add_anyway: "それでも追加", // CardCreationWidget — card creation form
  card_creator_needs_formatting_title: "質問にフォーマットが必要です", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_about: "「他者向け」バージョンがありません。AIで自動入力してフォーマットしますか?", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_general: "質問にフォーマットがないようです \u2014 ハイライトされた代名詞や{{tsar}}タグがありません。AIでフォーマットしますか?", // CardCreationWidget — warning props for CardWarning

  // ─── Card Warning ──────────────────────────────────────────────
  card_warning_do_not_show: "今後表示しない", // CardWarning — suppress checkbox
  card_warning_go_back: "戻る", // CardWarning — back button
  card_warning_enable_anyway: "それでも有効にする", // CardWarning — override button

  // ─── Admin Message Dialog ──────────────────────────────────────
  admin_message_title: "管理者からのメッセージ", // AdminMessageDialog — dialog title
  admin_message_reply_placeholder: "管理者に返信...", // AdminMessageDialog — reply input placeholder
  admin_message_reply_sent: "返信を送信しました!", // AdminMessageDialog — success message

  // ─── Shutdown Dialog ───────────────────────────────────────────
  shutdown_now: "今", // ShutdownDialog — countdown final text
  shutdown_title: "メンテナンス予定", // ShutdownDialog — dialog title
  shutdown_message_placeholder: "管理者にメッセージを残す...", // ShutdownDialog — message input placeholder
  shutdown_message_sent: "メッセージを送信しました!", // ShutdownDialog — success message

  // ─── Report Panel ──────────────────────────────────────────────
  report_panel_title: "カードの評価 / 報告", // ReportPanel — panel heading

  // ─── Preview Card ──────────────────────────────────────────────
  preview_card_probability: "確率: ", // PreviewCard — probability tooltip prefix

  // ─── Join Page ─────────────────────────────────────────────────
  join_name: "名前", // JoinPage — name field label
  join_exit: "退出", // JoinPage — exit button

  // ─── Teasers ───────────────────────────────────────────────────
  leaderboard_teaser_title: "トップクリエイター", // LeaderboardTeaser — section heading
  leaderboard_teaser_plays: "プレイ", // LeaderboardTeaser — play count unit
  leaderboard_teaser_empty: "クリエイターリーダーボード", // LeaderboardTeaser — empty state
  leaderboard_teaser_full: "全リーダーボード", // LeaderboardTeaser — full leaderboard link
  analytics_teaser_title: "トレンド", // AnalyticsTeaser — section heading
  analytics_teaser_desc: "ELOとプレイヤーグループの分析", // AnalyticsTeaser — description
  analytics_teaser_explore: "分析を探索", // AnalyticsTeaser — explore button
  gallery_teaser_title: "ギャラリー", // GalleryTeaser — section heading
  gallery_teaser_desc: "プレイヤーの絵を見る", // GalleryTeaser — description
  gallery_teaser_explore: "ギャラリーを探索", // GalleryTeaser — explore button
};

export default jp;
